export default "__VITE_ASSET__BeWHVpci__"